exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-events-[id]-tsx": () => import("./../../../src/pages/events/[id].tsx" /* webpackChunkName: "component---src-pages-events-[id]-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-productions-[id]-tsx": () => import("./../../../src/pages/productions/[id].tsx" /* webpackChunkName: "component---src-pages-productions-[id]-tsx" */)
}

